interface PropsType {
  style?: React.CSSProperties;
  color?: string;
}

const MailIcon = (props: PropsType) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_101_453)">
        <path
          d="M16.6667 3.3335H3.33333C2.41667 3.3335 1.66667 4.0835 1.66667 5.00016V15.0002C1.66667 15.9168 2.41667 16.6668 3.33333 16.6668H16.6667C17.5833 16.6668 18.3333 15.9168 18.3333 15.0002V5.00016C18.3333 4.0835 17.5833 3.3335 16.6667 3.3335ZM16.3333 6.87516L10.8833 10.2835C10.3417 10.6252 9.65833 10.6252 9.11667 10.2835L3.66667 6.87516C3.58311 6.82826 3.50993 6.76488 3.45157 6.68887C3.39321 6.61287 3.35088 6.52581 3.32715 6.43297C3.30341 6.34013 3.29875 6.24344 3.31346 6.14875C3.32817 6.05406 3.36195 5.96334 3.41273 5.88208C3.46352 5.80082 3.53027 5.73071 3.60894 5.67599C3.68761 5.62127 3.77656 5.58309 3.87041 5.56374C3.96427 5.5444 4.06107 5.5443 4.15496 5.56345C4.24885 5.5826 4.33789 5.62061 4.41667 5.67516L10 9.16683L15.5833 5.67516C15.6621 5.62061 15.7511 5.5826 15.845 5.56345C15.9389 5.5443 16.0357 5.5444 16.1296 5.56374C16.2234 5.58309 16.3124 5.62127 16.3911 5.67599C16.4697 5.73071 16.5365 5.80082 16.5873 5.88208C16.6381 5.96334 16.6718 6.05406 16.6865 6.14875C16.7012 6.24344 16.6966 6.34013 16.6729 6.43297C16.6491 6.52581 16.6068 6.61287 16.5484 6.68887C16.4901 6.76488 16.4169 6.82826 16.3333 6.87516Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_101_453">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default MailIcon;
